// 查询客户案例
import request from '@/untils/request/request.js'
export function queryOpertionPublicityByClient(params) {
  console.log(params);
  return request({
    url: `/sys/operationPublicity/queryOpertionPublicityByClient`,
    method: 'post',
    data: params
  })
}
// 查询案例详情
export function getOpertionPublicity(params) {
  console.log(params);
  return request({
    url: `/sys/operationPublicity/getOpertionPublicity`,
    method: 'post',
    data: params
  })
}
// 查询省级列表
export function getProvinceList() {
  return request({
    url: `/sys/area/getProvinceList`,
    method: 'get'
  })
}
// 查询市级列表
export function getCityList(provinceId) {
  return request({
    url: `/sys/area/getCityList/${provinceId}`,
    method: 'get'
  })
}
// 申请试用
export function applyTrial(params) {
  return request({
    url: `/apply/none/applyTrial`,
    method: 'post',
    data: params
  })
}


// WEBPACK FOOTER //
// ./src/api/publicinquiry.api.js